import React, { useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import Items from './movies.json'
import Categorys from './movies-categorys.json'
import Card from '../../elements/Card'
import FilterButtons from '../../elements/FilterButtons'
import Dropdown from '../../dropdown/Dropdown'

const Filter = () => {
  const [filter, setFilter] = useState('Todos')

  const isMobile = useMediaQuery({
    query: '(max-width: 768px)'
  })

  return (
    <>
      <section className="filterCine">
        <div className='container'>
          {isMobile ?
            <>
              <h2>Lo mejor del cine<br />en un sólo lugar</h2>
              <Dropdown value={filter} setValue={setFilter} options={["Todos", ...Categorys]} addStyle={{marginBottom: '24px'}} />
            </>
            :
            <>
              <h2>Lo mejor del cine en un sólo lugar</h2>
              <FilterButtons categorys={Categorys} filter={filter} setFilter={setFilter}  />
            </>}
          <section className="filterCine-cards">
            <Card Items={Items} filter={filter} isMobile={isMobile} />
          </section>
          <button className='btn-more-films'><span>Cargar más resultados</span></button>
        </div>
      </section>
    </>
  )
}

export default Filter

